import { push } from 'react-router-redux'

export default () => async (dispatch, getState) => {
  const { lead } = getState()

  // Send to homepage if lead has no address
  if (!lead || !lead.address) {
    dispatch(push('/'))
  }
}



// WEBPACK FOOTER //
// ./src/actions/redirectHomeIfEmpty.js